/**
 * The proposal extraction application's own routes, mounted by the shell at /proposals.
 *
 * Nothing in here knows it sits at /proposals — the prefix is the shell's decision, recorded once
 * in `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const JobsPage = lazy(() => import('@/apps/proposals/JobsPage'));
const JobDetailPage = lazy(() => import('@/apps/proposals/JobDetailPage'));
const JobReviewPage = lazy(() => import('@/apps/proposals/JobReviewPage'));
const TemplatesPage = lazy(() => import('@/apps/proposals/TemplatesPage'));
const JobCreatePage = lazy(() => import('@/apps/proposals/JobCreatePage'));
const TemplateNewPage = lazy(() => import('@/apps/proposals/TemplateNewPage'));
const ReadAccuracyPage = lazy(() => import('@/apps/proposals/ReadAccuracyPage'));

export const proposalsRoutes = (
  <Route path="proposals">
    <Route index element={<JobsPage />} />
    <Route path="jobs/new" element={<JobCreatePage />} />
    <Route path="jobs/:jobId" element={<JobDetailPage />} />
    <Route path="jobs/:jobId/edit" element={<JobCreatePage />} />
    <Route path="jobs/:jobId/review" element={<JobReviewPage />} />
    <Route path="templates" element={<TemplatesPage />} />
    <Route path="templates/new" element={<TemplateNewPage />} />
    <Route path="read-accuracy" element={<ReadAccuracyPage />} />
  </Route>
);
